
























import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import SubscriptionSignup from "@/store/modules/SubscriptionSignup";
import { bus } from "@/main";
import { getPromotionsByCode } from "@/helpers/api";

interface State {
  store: SubscriptionSignup;
  promoCodeInvalid: boolean;
  promoCodeInvalidMessage: string;
}

export default Vue.extend({
  name: "PromoCodeField",
  data(): State {
    return {
      store: getModule(SubscriptionSignup, this.$store),
      promoCodeInvalid: false,
      promoCodeInvalidMessage: ""
    };
  },
  methods: {
    async verifyCouponCode() {
      if (this.store.subscriptionVO.couponCode) {
        bus.$emit("loadingOn", "Loading");
        const code = this.store.subscriptionVO.couponCode;
        const promotions: any = code ? await getPromotionsByCode(code) : null;
        if (promotions.data && promotions.data.length > 0) {
          this.promoCodeInvalid = false;
          this.promoCodeInvalidMessage = "";
          this.store.setPromotion(promotions.data[0]);
          this.store.setShowPromo(false);
          bus.$emit("loadingOff");
          bus.$emit("successSnack", "Promo Code Applied");
        } else {
          bus.$emit("loadingOff");
          bus.$emit("errorSnack", "Invalid Promo Code");
          this.promoCodeInvalid = true;
          this.promoCodeInvalidMessage = "Invalid Promo Code";
        }
      }
    },
    resetInputValidation() {
      this.promoCodeInvalidMessage = "";
      this.promoCodeInvalid = false;
    }
  },
  computed: {
    applyBtnClass(): string {
      if (this.store.subscriptionVO.couponCode) {
        return "apply";
      } else {
        return "apply-disabled";
      }
    }
  }
});
